import React, { useState, useCallback } from 'react';
import { Handle, Position } from 'reactflow';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const ExpandableNode = ({ data, id }) => {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen(v => !v), []);
  const elementTitle = data.Title !== undefined ? data.Title : '';

  return (
    <>
      <div className="wrapper gradient">
        <div className="inner">
          <div className="body" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div className="title">{data.label}</div>
              {elementTitle && <div className="subline">{elementTitle}</div>}
            </div>
            <Button onClick={toggle} size="small" sx={{ minWidth: '30px', p: '5px' }}>
              {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Button>
          </div>
          <Handle type="target" position={Position.Top} style={{ top: '-4px', background: '#555' }} />
          <Handle type="source" position={Position.Bottom} style={{ bottom: '-4px', background: '#555' }} />
        </div>
      </div>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth={false} fullWidth PaperProps={{ style: { width: 'calc(100% - 280px)', height: '80%', maxWidth: 'none', marginLeft: 'auto' } }}>
        <DialogContent style={{ padding: 24 }}>
          {/* İç içe akış düzenleme ileride eklenecek */}
          Bu düğüm için iç akış düzenleme burada gösterilecek.
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ExpandableNode;

